import React, { FC, useEffect, useState } from "react";
import {
  ActionButtonsModel,
  LookupItemModel,
  ruleExpenseMoneySearchModel,
  SearchRuleExpenseMoneyRequestModel,
  PageEnum,
  RuleExpRecipeAccountsEnum,
  RequestActionModel,
  ActionTypeEnum,
  ValidationErrorModel,
  ToastModel,
  SearchFieldRequestModel,
  SearchItemRequestModel,
} from "../../models";

import {
  ConfirmModelDialogBox,
  PrivilegesChecker,
  RegisterRuleExpenseMoney,
  RuleExpenseMoneyList,
  LoadingBox,
  ErrorValidationBox,
  ToastBox,
  SearchBoxGeneric,
} from "..";
import { getLabelName, getUserId, scrollToDocumentTop } from "../../utils";
import { deleteAcTransaction } from "../../serviceBroker/acTransactionsApiServiceBroker";
import {
  searchRuleExpenseMoneyAccounts,
  searchRuleReceiveMoneyAccounts,
  selectAcTransaction,
} from "../../serviceBroker/accountApiServiceBroker";
import { Accordion } from "react-bootstrap";
import { useSearchBoxGeneric } from "../../hooks";

export const RuleExpenseComponent: FC<{
  acTransactionType: RuleExpRecipeAccountsEnum;
  formId: PageEnum;
}> = ({ acTransactionType, formId }) => {
  //#region variables
  const defaultPageSize: number = 50;
  const acTransactionInitValue: ruleExpenseMoneySearchModel = {
    Code: "",
    AccountType_ID: 0,
    Orders: 0,
    ArabicName: "",
    EnglishName: "",
    Parent_ID: 0,
    AllParent: "",
    RegisterInTrans: false,
    Active: true,
    Notes: "",
    BeginBalance: 0,
    Total_Money: 0,
    Money_Pay: 0,
    Balance: 0,
    ShowToUser: true,
    DateCreate: new Date(),
    BalanceInCurrency: 0,
    Account_UniqueID: "",
    TotalDebit: 0,
    TotalCredit: 0,
    NatureType: 0,
    IsParent: true,
    IsShowInCostCenter: false,
    AccountTypeId: 0,
    BranchID: 0,
    ID: 0,
    CreatedBy: 0,
    ModifiedBy: 0,
    Name: "",
    CreationDate: new Date(),
    ModificationDate: new Date(),
    VerifyOnUpdate: false,
    rowState: 1,
  };
  let searchPanelHeader = "";
  switch (+acTransactionType) {
    case RuleExpRecipeAccountsEnum.Expense:
      searchPanelHeader = "Expense Money Account";
      acTransactionInitValue.AccountType_ID = 1;
      break;
    case RuleExpRecipeAccountsEnum.Receive:
      searchPanelHeader = "Receive Money Account";
      acTransactionInitValue.AccountType_ID = 2;
      break;
    default:
  }

  //#endregion
  //#region state
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState<
    ValidationErrorModel[]
  >([]);
  const [toastModel, setToastModel] = useState<ToastModel>({ show: false });
  const [showAcTransactionModel, setShowAcTransactionModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState({
    show: false,
    id: 0,
  });
  const [showPrintModel, setShowPrintModel] = useState({
    show: false,
    content: "",
  });
  const [totalRows, setTotalRows] = useState(0);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [searchParams, setSearchParams] =
    useState<SearchRuleExpenseMoneyRequestModel>({
      pageNumber: 1,
      pageSize: defaultPageSize,
      accountId: 0,
    });
  const [acTransaction, setAcTransaction] =
    useState<ruleExpenseMoneySearchModel>(acTransactionInitValue);
  const [customerAccountLookups, setCustomerAccountLookups] = useState<
    LookupItemModel[]
  >([]);
  const [suppliersAccountLookups, setSuppliersAccountLookups] = useState<
    LookupItemModel[]
  >([]);
  const [userLookUps, setUserLookUps] = useState<LookupItemModel[]>([]);
  const [coastCenterLookUps, setCoastCenterLookUps] = useState<
    LookupItemModel[]
  >([]);
  const [currencyLookUps, setCurrencyLookUps] = useState<LookupItemModel[]>([]);
  const [acTransactionSearch, setAcTransactionSearch] = useState<
    SearchRuleExpenseMoneyRequestModel[]
  >([]);
  const initialSearchFields: SearchFieldRequestModel[] = [
    {
      key: "accountName",
      value: "",
      label: "Name",
      placeholder: "Enter Name",
      triggerSearchOnChange: true,
    },
    { key: "accountCode", value: "", label: "Code", placeholder: "Enter Code" },
  ];
  //#endregion
  //#region state
  const {
    fields: searchFields,
    onChange: handleSearchFieldChange,
    onSearch: handleSearch,
    onReset: handleResetSearch,
    searchedFields,
  } = useSearchBoxGeneric(initialSearchFields);
  //#endregion
  //#region useEffect
  useEffect(() => {
    const fillData = async () => {
      setLoading(true);
      await handelSearch();
      setLoading(false);
    };
    fillData().then(() => {});
  }, []);
  useEffect(() => {
    const updatedSearchRequest = searchFields.reduce<
      Partial<SearchRuleExpenseMoneyRequestModel>
    >((acc, field) => {
      if (field.key === "accountName") acc.accountName = field.value;
      if (field.key === "accountCode") acc.accountCode = field.value;
      return acc;
    }, {});
    setSearchParams((prev) => ({ ...prev, ...updatedSearchRequest }));
  }, [searchedFields]);
  useEffect(() => {
    const fillData = async () => {
      setLoading(true);
      await handelSearch();
      setLoading(false);
    };
    fillData().then(() => {});
  }, [
    searchParams.pageNumber,
    searchParams.pageSize,
    // acTransactionSearch.searchGuid,
    searchParams.accountName,
    searchParams.accountCode,
  ]);
  //#endregion
  //#region functions
  const handelSearch = async () => {
    setLoading(true);
    let response;
    if (acTransactionType == RuleExpRecipeAccountsEnum.Expense) {
      response = await searchRuleExpenseMoneyAccounts(searchParams);
    } else {
      response = await searchRuleReceiveMoneyAccounts(searchParams);
    }

    if (response.Result != undefined) {
      setAcTransactionSearch(response.Result);
    } else {
      setAcTransactionSearch([]);
    }
    if (response.TotalRecoredCount !== undefined) {
      setTotalRows(response.TotalRecoredCount);
    } else {
      setTotalRows(0);
    }
    setLoading(false);
  };
  const onCurrentPageChange = async (pageNumber: number) => {
    if (pageNumber !== searchParams.pageNumber) {
      const obj = { ...searchParams };
      obj.pageNumber = pageNumber;
      setSearchParams(obj);
      await handelSearch();
    }
  };
  const onPageSizeChange = async (pageSize: number) => {
    if (pageSize !== searchParams.pageSize) {
      const obj = { ...searchParams };
      obj.pageSize = pageSize;
      setSearchParams(obj);
      await handelSearch();
    }
  };
  const handleSaveEmployeeComplete = async (isSaveComplete: boolean) => {
    if (isSaveComplete) {
      setShowAcTransactionModel(false);
      await handelSearch();
    } else {
      setShowAcTransactionModel(false);
      setAcTransaction(acTransactionInitValue);
    }
  };
  const deleteEmployeeActions: ActionButtonsModel[] = [
    {
      text: getLabelName("yes"),
      onClick: async () => {
        setValidationErrors([]);
        setLoading(true);
        const result = await deleteAcTransaction(
          showDeleteModel.id,
          getUserId()
        );
        const isSuccess: boolean = !(
          result.Errors != null && result.Errors.length !== 0
        );
        setLoading(false);
        setShowDeleteModel({ show: false, id: 0 });
        if (isSuccess) {
          setToastModel({
            ...toastModel,
            variant: "success",
            show: true,
          });
          await handelSearch();
        } else {
          scrollToDocumentTop();
          setValidationErrors(result?.Errors || []);
        }
      },
    },
    {
      text: getLabelName("No"),
      onClick: () => {
        setShowDeleteModel({ show: false, id: 0 });
      },
    },
  ];
  const onActionEvent = async (request: RequestActionModel) => {
    switch (request.action) {
      case ActionTypeEnum.Update:
        setIsFormLoading(true);
        const response = await selectAcTransaction(request.id!);
        setAcTransaction(response?.Result as ruleExpenseMoneySearchModel);
        setShowAcTransactionModel(true);
        setIsFormLoading(false);
        break;
      case ActionTypeEnum.Delete:
        setShowDeleteModel({ show: true, id: request.id || 0 });
        break;
      case ActionTypeEnum.Clear:
        setAcTransaction(acTransactionInitValue);
        setValidationErrors([]);
        break;
    }
  };
  //#endregion
  //#region html
  return (
    <>
      {loading && <LoadingBox />}
      {<ErrorValidationBox errors={validationErrors} />}
      {toastModel.show && (
        <ToastBox
          isShown={toastModel.show}
          header={toastModel.header}
          body={toastModel.body}
          variant={toastModel.variant}
          delayDuration={toastModel.delayDuration}
          onCloseEvent={() => {
            setToastModel({ ...toastModel, show: false });
          }}
        />
      )}
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            {getLabelName(
              formId === PageEnum.RuleExport ? "Rule Export" : "Rule Recive"
            )}
          </Accordion.Header>
          <Accordion.Body>
            <RegisterRuleExpenseMoney
              formID={formId}
              searchPanelHeader={searchPanelHeader}
              acTransactionType={acTransactionType}
              acTransaction={acTransaction}
              setLoading={setLoading}
              customerAccountLookups={customerAccountLookups}
              handleSaveEmployeeComplete={handleSaveEmployeeComplete}
              currencyLookUps={currencyLookUps}
              coastCenterLookUps={coastCenterLookUps}
              suppliersAccountLookups={suppliersAccountLookups}
              onActionEvent={onActionEvent}
              setIsFormLoading={setIsFormLoading}
              isFormLoading={isFormLoading}
            />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>{getLabelName("Previous Data")}</Accordion.Header>
          <Accordion.Body>
            <PrivilegesChecker formId={formId} action="EnableSearch">
              <SearchBoxGeneric
                searchFields={searchFields}
                onChangeHandler={handleSearchFieldChange}
                onSearchHandler={handleSearch}
                onResetHandler={handleResetSearch}
              />
            </PrivilegesChecker>

            <RuleExpenseMoneyList
              acTransactionSearch={acTransactionSearch}
              totalRows={totalRows}
              searchParams={searchParams}
              defaultPageSize={defaultPageSize}
              onCurrentPageChange={onCurrentPageChange}
              onPageSizeChange={onPageSizeChange}
              setShowAcTransactionModel={setShowAcTransactionModel}
              setAcTransaction={setAcTransaction}
              setShowDeleteModel={setShowDeleteModel}
              setShowPrintModel={setShowPrintModel}
              loading={loading}
              setLoading={setLoading}
              formID={formId}
              onActionEvent={onActionEvent}
              setIsFormLoading={setIsFormLoading}
            />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <ConfirmModelDialogBox
        isModelVisible={showDeleteModel.show}
        onCloseEvent={() => {
          setShowDeleteModel({ show: false, id: 0 });
        }}
        actions={deleteEmployeeActions}
      >
        <div className="alert alert-warning">
          {`${getLabelName("are you sure you want delete")}`}
        </div>
      </ConfirmModelDialogBox>
    </>
  );
  //#endregion
};
